export default {
  // https://issuehunt.io/r/kazupon/vue-i18n/issues/759
  methods: {
    i18nArray(source) {
      return Object.values(source).map( e => { return { value: e.label, text: e.value } } );
    },
  }
};